import React from "react";
import { Grid, Box, Typography, makeStyles } from "@material-ui/core";
import { white } from "../../constants/colors";
import Navbar from "../../components/Navbar/Navbar";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  mainForm: {
    height: "calc(100vh - 180px)",
    backgroundColor: white,
    padding: "30px 60px",
    borderTopRightRadius: "50px",
    borderTopLeftRadius: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [down("sm")]: {
      padding: "30px 40px",
    },
    [down("xs")]: {
      padding: "25px 10px",
      borderTopRightRadius: "20px",
      borderTopLeftRadius: "20px",
    },
  },
}));

const NotFoundPage = () => {
  const classes = useStyles();
  return (
    <>
      <Navbar />
      <Grid container>
        <Grid item xs={12} className={classes.mainForm}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography variant="h2">NOT FOUND</Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default NotFoundPage;
